import ProxyBase from '../ProxyBase';
import ServiceProxyConfig from '../../../configs/ServiceProxyConfig';

class TimeAndSaleProxy extends ProxyBase {
  getTimeAndSale(data) {
    return this.get('GetTimeAndSales', data);
  }

  exportTable(params) {
    return this.get('DownloadTimeAndSales', params, null, 'download');
  }

  getBuSdChart(params) {
    return this.get('GetTimeAndSalesBuSdChart', params);
  }

  getStatChartData(params) {
    return this.get('GetTimeAndSalesStatChart', params);
  }
}

const timeAndSaleProxy = new TimeAndSaleProxy(
  ServiceProxyConfig.Prices.TimeAndSaleUrl,
);
export default timeAndSaleProxy;
